import emailjs from '@emailjs/browser';

export async function sendContactEmail(formData) {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  if (!serviceId || !templateId || !publicKey) {
    throw new Error('EmailJS non configuré (REACT_APP_EMAILJS_SERVICE_ID / TEMPLATE_ID / PUBLIC_KEY)');
  }

  const templateParams = {
    nom: formData.nom,
    prenom: formData.prenom,
    email: formData.email,
    telephone: formData.telephone,
    typeProjet: formData.typeProjet,
    surface: formData.surface,
    description: formData.description,
    submittedAt: new Date().toLocaleString()
  };

  const response = await emailjs.send(serviceId, templateId, templateParams, {
    publicKey
  });

  return response;
}


